import React from 'react';
import { Image } from '@noths/polaris-client-ribbons-design-system';

import type { Product, Sticker as StickerType } from 'src/types/dontgiftguide';
import { ImagePresentation } from 'src/types/dontgiftguide';
import { parseCopy } from '../../../../utils/parseCopy';
import { ProductLabel } from '../../atoms/ProductLabel/ProductLabel';
import { Sticker } from '../../atoms/Stickers/Sticker/Sticker';
import { Content } from '../../molecules/Content/Content';
import * as styles from './FeatureSection.styles';

export interface FeatureSectionProps {
  onLinkClick: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  imagePresentation: ImagePresentation;
  copy: string;
  darkCopyColor: boolean;
  backgroundColor?: string;
  product?: Product;
  sticker: StickerType;
}

export const FeatureSection = (props: FeatureSectionProps) => {
  const { onLinkClick, imagePresentation, copy, darkCopyColor, backgroundColor, product, sticker } =
    props;
  const parsedCopy = parseCopy(copy);

  return product ? (
    <Content darkCopyColor={darkCopyColor}>
      <div css={styles.featureSection} style={{ backgroundColor }}>
        <a css={styles.link} href={product.href} onClick={onLinkClick}>
          <div css={styles.product}>
            <Image
              src={product.image.original}
              alt=""
              css={
                imagePresentation === ImagePresentation.Arch ? styles.archImage : styles.circleImage
              }
              loading="lazy"
            />
            {sticker && (
              <div
                css={[
                  styles.stickerContainer,
                  imagePresentation === ImagePresentation.Arch
                    ? styles.topLeftSticker
                    : styles.bottomRightSticker,
                ]}
              >
                <Sticker shape={sticker.shape} color={sticker.color} content={sticker.content} />
              </div>
            )}
          </div>
          {parsedCopy && <p css={styles.copy}>{parsedCopy}</p>}
          <p css={styles.productLabel}>
            <ProductLabel product={product} />
          </p>
        </a>
      </div>
    </Content>
  ) : null;
};
